module.exports = __webpack_public_path__ + "static/media/18ECA33.a0a468d6.jpg";